import { YYYYMMDDFormat } from "@/filters/date";
import moment, { Moment } from "moment-timezone";
import { constants } from "./constants";

/**
 * Determines whether a given time range qualifies as an all-day event.
 * Returns true if the event duration is between 23 hours 59 minutes and 24 hours; otherwise, false.
 */
export function isAllDayEvent(start: string, end: string): boolean {
  try {
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Calculate the total time difference in milliseconds
    const timeDifferenceInMilliseconds = endDate.getTime() - startDate.getTime();

    // Minimum duration for an all-day event: 23 hours 59 minutes (in milliseconds)
    // Maximum duration for an all-day event: 24 hours 00 minutes (in milliseconds)
    const minimumDurationInMilliseconds = 23 * 60 * 60 * 1000 + 59 * 60 * 1000;
    const maximumDurationInMilliseconds = 24 * 60 * 60 * 1000;

    // Check if the time difference is at least 23:59:00 and no more than 24:00:00
    return timeDifferenceInMilliseconds >= minimumDurationInMilliseconds && timeDifferenceInMilliseconds <= maximumDurationInMilliseconds;
  } catch (error) {
    return false;
  }
}

export function updateDateFormat(date: string | Moment, format: string) {
  const dateValue = typeof date === "string" ? new Date(date) : date;
  return moment(dateValue).format(format);
}

export function getProductLocalDate(start: string, localTimezone: string) {
  const timezone = localTimezone || constants.DEFAULT_TIMEZONE;
  return moment.utc(start).tz(timezone).format(YYYYMMDDFormat);
}

export function isPastDateTimeZone(start: string, localTimezone: string) {
  if (!start) return true;
  const timezone = localTimezone || constants.DEFAULT_TIMEZONE;
  const today = moment.tz(timezone).format(YYYYMMDDFormat);
  return getProductLocalDate(start, timezone) < today;
}
